import React from "react";
import { useSelector } from "react-redux";
import { formatToCompanyTimezone, toCompanyDateOnlyforReportDateFilter } from "../../../../lib/functions";
import commaNumber from "comma-number";
import InstitutionProfile from "../../../../components/common/InstitutionProfile";
import "../../../../components/common/bt.css";

const format = commaNumber.bindWith(",", ".");

const CreditorPaymentRecordPrint = React.forwardRef(({ filters, selectedSupplier }, ref) => {
  const { list } = useSelector((state) => state.creditorPaymentRecord);

  const isWithDetails = filters.recordType === "with details";

  const totals = list.reduce(
    (acc, row) => {
      if (!row.isSubtotal) {
        acc.total += Number(row.pay_total || 0);
      }
      return acc;
    },
    { total: 0 }
  );

  return (
    <div ref={ref} style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <InstitutionProfile />

      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <h2>Creditor/Supplier Payment Record</h2>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <p><strong>Filter Type:</strong> {filters.filterType}</p>
        <p>
          <strong>Statement:</strong> {filters.fromDate && toCompanyDateOnlyforReportDateFilter(filters.fromDate).format("DD/MM/YYYY")} - {filters.toDate && toCompanyDateOnlyforReportDateFilter(filters.toDate).format("DD/MM/YYYY")}
        </p>
      </div>

      <table className="ledger-print-table">
        {isWithDetails ? (
          <colgroup>
            <col style={{ width: "4%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "22%" }} />
            <col style={{ width: "16%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "18%" }} />
          </colgroup>
        ) : (
          <colgroup>
            <col style={{ width: "5%" }} />
            <col style={{ width: "12%" }} />
            <col style={{ width: "12%" }} />
            <col style={{ width: "30%" }} />
            <col style={{ width: "21%" }} />
            <col style={{ width: "20%" }} />
          </colgroup>
        )}
        <tbody>
          <tr className="ledger-print-heading">
            <td>No.</td>
            <td>{isWithDetails ? "VCH" : "VCH No"}</td>
            <td>Date</td>
            <td>Creditor/Supplier</td>
            <td>Payment By</td>
            {isWithDetails ? (
              <>
                <td>Payment From</td>
                <td style={{ textAlign: "right" }}>Payment Amount</td>
              </>
            ) : (
              <td style={{ textAlign: "right" }}>Total Amount</td>
            )}
          </tr>

          {list.map((row, index) =>
            row.isSubtotal ? (
              <tr className="ledger-opening-row" key={row.id || index}>
                <td colSpan={5} style={{ textAlign: "right" }}>
                  Sub Total
                </td>
                <td />
                <td style={{ textAlign: "right" }}>
                  {format((row.subtotal || 0).toFixed(2))}
                </td>
              </tr>
            ) : (
              <tr key={row.id || index}>
                <td>{index + 1}</td>
                <td>{row.pay_code}</td>
                <td>{row.created_date ? formatToCompanyTimezone(row.created_date).split(" ")[0] : "-"}</td>
                <td>{row.acc_name}</td>
                <td>{row.full_name}</td>
                {isWithDetails ? (
                  <>
                    <td>{row.from_acc_name}</td>
                    <td style={{ textAlign: "right" }}>
                      {format(parseFloat(row.pay_total || 0).toFixed(2))}
                    </td>
                  </>
                ) : (
                  <td style={{ textAlign: "right" }}>
                    {format(parseFloat(row.pay_total || 0).toFixed(2))}
                  </td>
                )}
              </tr>
            )
          )}

          <tr className="ledger-total-row">
            <td colSpan={isWithDetails ? 6 : 5} style={{ textAlign: "right" }}>
              Grand Total
            </td>
            <td style={{ textAlign: "right" }}>{format(totals.total.toFixed(2))}</td>
          </tr>
        </tbody>
      </table>

      <div style={{ marginTop: "50px", display: "flex", justifyContent: "space-between" }}>
        <div style={{ borderTop: "1px solid #000", width: "150px", textAlign: "center" }}>
          Received By
        </div>
        <div style={{ borderTop: "1px solid #000", width: "150px", textAlign: "center" }}>
          Authorized By
        </div>
      </div>
    </div>
  );
});

export default CreditorPaymentRecordPrint;
